import React from 'react';
import { Umbrella } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function InsuranceProtectionPage() {
  const module = getModule('insurance-protection')!;
  return (
    <ModulePageLayout module={module} Icon={Umbrella}>
      <Section title="Device & Travel Coverage, Built In">
        <p className="text-gray-700 leading-relaxed">
          Insurance & Protection bundles device coverage and travel insurance into your Bankably account.
          Each policy tracks its start and end date, total premium, and status, with a reseller network
          enabling third parties to distribute the same products and earn commissions.
        </p>
      </Section>

      <Section title="Filing and Tracking a Claim">
        <Steps
          items={[
            'A covered event happens — device damage, loss, or a travel disruption.',
            'You file a claim with a date, description, amount, and supporting documents.',
            'It moves through review: Pending → Approved or Rejected.',
            'Approved claims are paid out, with the payout tracked alongside premium payments and commissions in your transaction history.',
          ]}
        />
      </Section>

      <Section title="What's Tracked">
        <FeatureGrid
          items={[
            { title: 'Policy Coverage', body: 'Coverage types are stored flexibly to support both device protection and travel insurance under one policy structure.' },
            { title: 'Reseller Network', body: 'Third-party resellers can distribute insurance products and earn commissions on what they sell.' },
            { title: 'Full Transaction History', body: 'Premium payments, claim payouts, and commissions are all classified and tracked individually.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
